"use client";

import { Fish, Sprout, Wine } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Videosolutionyealink() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const features = [{
    icon: Sprout,
    label: "VOZ IP"
  }, {
    icon: Fish,
    label: "VIDEO HD"
  }, {
    icon: Wine,
    label: "COLABORACIÓN"
  }];
  return <section data-section-id="85" id="videosolutionyealink" className="bg-background text-foreground relative overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[600px] lg:min-h-[720px]">
        {/* Image Column */}
        <div ref={imageRef} className={`relative overflow-hidden h-[400px] sm:h-[500px] lg:h-auto transition-all duration-1000 ease-out ${imageVisible ? "opacity-100" : "opacity-0"}`}>
          <img data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/yealink_video_conference_system.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/yealink_video_conference_system.png-wvc-sizes" alt="Sistema de videoconferencia Yealink en sala de juntas moderna" loading="lazy" decoding="async" className="h-full object-cover transition-transform duration-[2000ms] ease-out scale-100 translate-y-0 !border-1 border-[rgb(51,51,51)] !border-none !w-[688px]" src="https://avtecsa.com/wp-content/uploads/2026/09/5f427851-0d3d-4d08-83e2-4e4e62e8072e.png" />
          {/* Overlay Gradient */}
          <div className="absolute inset-0 pointer-events-none" style={{
          background: "radial-gradient(ellipse at center, transparent 40%, hsla(200, 85%, 10%, 0.35) 100%)"
        }} />
          {/* Subtle Brand Tint */}
          <div className="absolute inset-0 pointer-events-none bg-primary/10 mix-blend-overlay" />
        </div>

        {/* Text Column */}
        <div ref={textRef} className="relative flex items-center justify-center px-6 sm:px-10 lg:px-16 xl:px-24 py-16 lg:py-24 bg-muted">
          <div className={`max-w-xl w-full transition-all duration-1000 ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            {/* Subtitle */}
            <div className="flex items-center gap-3 mb-8">
              <span className="block h-px w-8 bg-primary" />
              <span className="font-mono text-xs tracking-[0.25em] uppercase text-primary">
                Soluciones Yealink
              </span>
            </div>

            {/* Heading */}
            <h2 className="font-default font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight mb-8 text-foreground">
              Comunicación sin
              <br />
              <em className="italic font-medium text-secondary">
                fronteras,
              </em>
              <br />
              con AVTECSA.
            </h2>

            {/* Paragraph */}
            <p className="font-default text-base sm:text-lg leading-relaxed mb-10 max-w-md text-muted-foreground">
              Potenciamos su empresa con terminales Yealink de última generación. Integración nativa con MS Teams y sistemas PBX para una experiencia de colaboración fluida y profesional.
            </p>

            {/* Features Grid */}
            <div className="flex items-start justify-between sm:justify-start sm:gap-12 mb-10 pb-10 border-b border-border">
              {features.map((feature, i) => {
              const Icon = feature.icon;
              return <div key={feature.label} data-index={i} className="flex flex-col items-center sm:items-start gap-3">
                    <Icon className="w-6 h-6 text-primary" strokeWidth={1.5} />
                    <span className="font-mono text-[10px] sm:text-xs tracking-[0.2em] uppercase text-center sm:text-left text-muted-foreground">
                      {feature.label}
                    </span>
                  </div>;
            })}
            </div>

            {/* CTA Button */}
            <Button asChild variant="link" className="p-0 h-auto font-default text-sm tracking-wider uppercase hover:no-underline group text-primary">
              <Link to="/YealinkProductPage">
                <span className="border-b border-primary pb-1 transition-all duration-300 group-hover:border-b-2">
                  Ver catálogo Yealink
                </span>
                <span className="ml-2 transition-transform duration-300 group-hover:translate-x-1">
                  &rarr;
                </span>
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}